import { useState } from 'react';
import { NotFound } from '../views';

export const useNotFound = () => {
  const [notFound, setNotFound] = useState(false);

  return { notFound, setNotFound, NotFound };
};
